import { SelectItem } from "./SelectItem";

// Every residence permit request (the GET, the save POST, the EU/EEA PUT and the EU/EEA country
// list) gets this deadline instead of HttpService's 120 s default: the editor and the scorecard's
// Approve wait on them, so a stuck CRM ends in a Retry or an error toast, not two minutes of silence.
export const RESIDENCE_PERMIT_REQUEST_TIMEOUT_MS = 15000;

// Mirrors Alaric.Domains.CommonDb/Model/Enums/ResidencePermitType.cs (tenn-pay-crm). CRM serializes
// enums as numbers, so the numeric values are the contract.
export enum ResidencePermitType {
    CardOfEuEeaResident = 1,
    LongTermEuResidencePermit = 2,
    NationalResidencePermit = 3,
    PermanentResidence = 4,
    Other = 5,
}

export const residencePermitTypeOptions: SelectItem<number>[] = [
    { label: "Card of EU/EEA Resident", value: ResidencePermitType.CardOfEuEeaResident },
    { label: "Long-term EU Residence Permit", value: ResidencePermitType.LongTermEuResidencePermit },
    { label: "National Residence Permit", value: ResidencePermitType.NationalResidencePermit },
    { label: "Permanent Residence", value: ResidencePermitType.PermanentResidence },
    { label: "Other", value: ResidencePermitType.Other },
];

// ResidencePermitDataModel (tenn-pay-crm): one row of IndividualIdentityDocuments. Dates are
// date-only; they arrive as "yyyy-MM-ddT00:00:00" and are sent as "yyyy-MM-dd" (see
// toDateOnlyString/fromDateOnlyString in Pages/Users/residencePermitRules.ts).
export interface ResidencePermit {
    id: number;
    individualId: number;
    permitType: ResidencePermitType;
    foreignerPersonalNumber: string;
    documentNumber: string;
    issuingCountryCode: string;
    issuingAuthority: string | null;
    dateOfIssue: string;
    dateOfExpiry: string | null;
    noExpirationDate: boolean;
    reason: string;
    // false = an earlier or deactivated permit, kept as history.
    isActive: boolean;
}

// IndividualResidencePermitModel — GET /Individual/{individualId}/residence-permit.
export interface ResidencePermitResponse {
    // true hides the whole section: every recorded nationality is EU/EEA.
    isMemberOfEuEea: boolean;
    // Whether the caller may create or edit residence permits (computed by CRM from permissions).
    canEditResidencePermit: boolean;
    // Every recorded permit, active one first; empty, never null, when none was recorded.
    residencePermitData: ResidencePermit[];
}

// SaveResidencePermitRequest — POST /Individual/{submissionId}/residence-permit, sent on "Done".
// Each change records a new row and, when active, makes it the individual's only active permit;
// the same call refreshes the permit snapshot and gate flag on the KYC submission.
export interface SaveResidencePermitRequest {
    individualId: number;
    permitType: ResidencePermitType;
    foreignerPersonalNumber: string;
    documentNumber: string;
    issuingCountryCode: string;
    issuingAuthority: string;
    dateOfIssue: string;
    dateOfExpiry: string | null;
    noExpirationDate: boolean;
    isActive: boolean;
    // Mandatory Reason control of the edit dialog (5-500 characters).
    reason: string;
}

// SaveResidencePermitResultModel — the POST response.
export interface SaveResidencePermitResult {
    // false when the data matched the current permit and nothing was written.
    dataChanged: boolean;
    message: string;
    permit: ResidencePermit | null;
}
